import React from "react";
import "./SwitchCheckBox.scss";

export default function SwitchCheckBox(props) {

    const onChange = (e) => {
        if (props.onChange)
        {
            props.onChange(e.target.checked)
        }
    }
    
    return (
        <label className="switch-checkbox">
            <input
                type="checkbox"
                checked={props.checked}
                onChange={onChange}
            />
            <span className="slider"></span>
        </label>
    );
}
